import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  viewBox?: string;
}

const FileIcon = (props: Props): ReactElement => {
  const { width, height, style, viewBox } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox={viewBox}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M14.29 3.335l.789.79h-.001l3.338 3.34c.214.215.335.507.334.811l-.002.675v9.799c0 1.23-.987 2.23-2.212 2.25H7.499c-1.23 0-2.229-.987-2.249-2.213V5.25c0-1.23.987-2.23 2.213-2.25h6.019c.303 0 .594.12.808.335zm-1.166.79H7.5c-.612 0-1.11.488-1.125 1.096V18.75c0 .612.488 1.11 1.096 1.125H16.5c.611 0 1.109-.488 1.124-1.096V9h-2.25c-1.23 0-2.229-.987-2.249-2.213V4.125zm2.718 12.75c.311 0 .563.252.563.563 0 .31-.252.562-.563.562H8.156c-.31 0-.563-.252-.563-.562 0-.311.252-.563.563-.563h7.686zm0-2.25c.311 0 .563.252.563.563 0 .31-.252.562-.563.562H8.156c-.31 0-.563-.252-.563-.562 0-.311.252-.563.563-.563h7.686zm0-2.25c.311 0 .563.252.563.563 0 .31-.252.562-.563.562H8.156c-.31 0-.563-.252-.563-.562 0-.311.252-.563.563-.563h7.686zm0-2.25c.311 0 .563.252.563.563 0 .31-.252.562-.563.562H8.156c-.31 0-.563-.252-.563-.562 0-.311.252-.563.563-.563h7.686zM14.25 4.873V6.75c0 .612.488 1.11 1.096 1.125H17.25l-3.001-3.002zM11.437 6c.31 0 .562.252.562.563 0 .31-.252.562-.562.562H8.062c-.31 0-.562-.252-.562-.562 0-.311.252-.563.562-.563h3.375z"
          transform="translate(-378 -516) translate(290 24) translate(22 200) translate(2 96) translate(0 176) translate(64 20)"
        />
      </g>
    </svg>
  );
};

FileIcon.defaultProps = {
  width: '24px',
  height: '24px',
  style: {},
  viewBox: '0 0 24 24',
};

export default FileIcon;
